<template>
<div>
  <v-flex
      class="blog-post-container"
      >

     <h1 v-if="activeBlog.title">{{activeBlog.title}}</h1>
     <div class="blog-post-desc">{{$lang.blog.written_by}}: <span style="color:#3CCEBD">{{activeBlog.author}}</span>  |  {{getDate(activeBlog.date)}}  |  {{activeBlog.duration}} </div>
      <div 
        v-for="(post, index) in activeBlog.content"
        :key="index"
      class="blog-post" v-bind:class="{'blog-post':true, 'center':post.image || post.youtube}">

        
        <h1 v-if="post.title">{{post.title}}</h1>
        <h1 class="subTitle" v-else-if="post.subTitle">{{post.subTitle}}</h1>
        <h2 class="subtitle" v-else-if="post.header">{{post.header}}</h2>
        <p v-else-if="post.content" v-html="post.content">{{post.content}}</p>
        <ul v-else-if="post.listing">
            <li v-for="(list, index) in post.listing" :key="index" v-html="list"></li>
        </ul>
          <img v-else-if="post.image" :src="getImageRelativePath(post.image.src)" :width="post.image.width || '500px'"/>
          <div v-else-if="post.seperator" class="section-divider" :style="`width:100%;margin-top:${post.seperator};margin-bottom:${post.seperator};`">
          </div>

        <iframe
        v-else-if="post.youtube"
          width="560"
          height="315"
          :src="post.youtube"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>
        <!-- <img v-else-if="post.image" :src="getImageRelativePath(`${post.image}`)"/> -->
        <!-- <img v-else-if="post.image" src="../../assets/images/zoom/zoom_upload.webp"/> -->
        <br>
      </div>
        
      </v-flex>
    </div>
</template>

<script>
// import blogFeedData from "@/resources/blogs/en-us"
const images = require.context('../../assets/images/', true, /\.webp$/)
export default {
  name: "BlogPost",
  props: ['activeBlog'],
  methods:{
    getImageRelativePath(url){
      var isRelativePath = url.indexOf('./') === 0;
      return isRelativePath ? images(url) : url;
    },
    getDate(date){
        const me = this;
        let tempDate = new Date(date * 1000)
        let month = tempDate.toLocaleString('default', { month: 'long' });
        
        return me.$lang.common[month.toLowerCase()]+' '+tempDate.getDate()+me.$lang.common['th']
    }
  }
};
</script>

<style scoped>
.blog-post-container{
    padding:50px 200px;
    text-align: left;
}

.blog-post-desc{
    color:#797676;
    padding-top: 40px;
    padding-bottom: 10px;
}

.blog-post-container .section-divider{
  text-align: center;
}

.blog-post-container .section-divider::before{
    content: '...';
    display: inline-block;
    margin-left: 0.6em;
    color: rgba(0,0,0,.68);
    position: relative;
    font-size: 50px;
    letter-spacing: 50px;
}

.blog-post li{
 padding:5px 20px;
}


.blog-post.center{
  text-align: center;
}
@media only screen and (max-device-width: 600px) {
.blog-post-container {
    padding: 20px 30px 100px 30px;
}

}

</style>

<style >
.blog-post{
  -webkit-transition: all 100ms ease-in-out;
  -moz-transition: all 100ms ease-in-out;
  -o-transition: all 100ms ease-in-out;
  transition: all 100ms ease-in-out;
}
.blog-post iframe{
  margin:40px 0px;
}
.blog-post li>p{
 padding:10px;
}

.blog-post a{
  -webkit-transition: all 100ms ease-in-out;
  -moz-transition: all 100ms ease-in-out;
  -o-transition: all 100ms ease-in-out;
  transition: all 100ms ease-in-out;

}

.blog-post a:hover{
  color:#0884e2!important;
}
@media only screen and (max-device-width: 600px) {
.blog-post iframe{
    width:100%;
}
.blog-post img{
    width:100%;
}
}

</style>